const getQueryUrl = (id, url) => {
  const query = url || window.location.search.substring(1);
  const vars = query.split('&');
  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] === id) {
      return pair[1];
    }
  }
  return false;
}
const getUrlInfo = (protocol, port, host) => {
  // eslint-disable-next-line no-underscore-dangle
  let _url = '';
  // eslint-disable-next-line no-unused-expressions
  protocol === 'protocol' && (_url += `${window.location.protocol}//`)
  // eslint-disable-next-line no-unused-expressions
  port === 'port' && (_url += window.location.port)
  // eslint-disable-next-line no-unused-expressions
  host === 'host' && (_url += window.location.host)
  return _url
}
export {
  // eslint-disable-next-line import/prefer-default-export
  getQueryUrl,
  getUrlInfo,
}
